import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../contexts/AuthContext';
import { ClipboardList, X } from 'lucide-react';

export default function ReviewAlertBanner() {
  const location = useLocation();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(`perfAlertDismissed-${new Date().toISOString().slice(0, 10)}`) === '1');
  const lastFetch = useRef(0);

  useEffect(() => {
    const now = Date.now();
    if (now - lastFetch.current < 60000) return;
    lastFetch.current = now;
    api.get('/perf/alert').then(r => setItems(r.data.items || [])).catch(() => {});
  }, [location.pathname]);

  if (dismissed || items.length === 0 || location.pathname === '/my-reviews' || location.pathname === '/onboarding') return null;

  const overdue = items.some(i => i.overdue);
  const first = items[0];
  const what = first.kind === 'self' ? `your self-review for "${first.period}"` : `the manager review for ${first.employee_name}`;
  const due = first.due_date ? (first.overdue ? ` — was due ${first.due_date}` : ` — due by ${first.due_date}`) : '';

  return (
    <div className={`flex items-center gap-3 px-4 py-2.5 text-sm font-semibold text-white ${overdue ? 'bg-[#C0392B]' : 'bg-[#B45309]'}`}
         data-testid="review-alert-banner">
      <ClipboardList className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-0 truncate">
        {items.length === 1
          ? <>Performance review waiting: {what}{due}</>
          : <>{items.length} performance review tasks are waiting on you{overdue ? ' (some overdue)' : ''}</>}
      </span>
      <button onClick={() => navigate('/my-reviews')} data-testid="review-alert-go"
              className="shrink-0 rounded-full bg-white/20 hover:bg-white/30 px-3 py-1 text-xs font-bold transition-colors">
        Complete now
      </button>
      <button onClick={() => { sessionStorage.setItem(`perfAlertDismissed-${new Date().toISOString().slice(0, 10)}`, '1'); setDismissed(true); }}
              data-testid="review-alert-dismiss" className="shrink-0 opacity-70 hover:opacity-100">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
